var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('yz-skeleton-loader',{attrs:{"type":"article"}}),_c('yz-skeleton-loader',{staticClass:"mt-4",attrs:{"type":"card"}}),_c('yz-skeleton-loader',{staticClass:"mt-4",attrs:{"type":"article"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }